import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaHardHat, FaPaintRoller, FaLeaf, FaCheckCircle, FaPhone } from 'react-icons/fa'; // Ícones para Marcenaria
import { LuPiano } from "react-icons/lu";
import { GiWoodBeam } from "react-icons/gi";
import SeoHead from "../../components/Menu/components/SeoHead";


import '../../assets/css/servicomarcenaria.css'; // CSS específico para esta página

const ServicoMarcenaria = () => {
const galleryImages = [
  { 
    id: 1, 
    src: '/img/marcenaria/1.jpg', 
    alt: 'Recuperações ao estado orginal como novo.' 
  },
  { 
    id: 2, 
    src: '/img/marcenaria/2.jpg', 
    alt: 'Restauração completa do móvel.' 
  },
  { 
    id: 3, 
    src: '/img/marcenaria/3.jpg', 
    alt: 'São mais de 56 anos de revitalizações perfeitas .' 
  },
  { 
    id: 4, 
    src: '/img/marcenaria/4.jpg', 
    alt: 'Conhecimento técnico para praticamente novas fabricações.' 
  },
];


const marcenariaSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Restauração de Pianos - Serviço de Marcenaria",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Waldir Pianos",
    "image": "https://pianoswaldir.com.br/images/logo.jpg"
  },
  "description": "Serviço especializado em marcenaria para pianos, com recuperação da madeira e estrutura do instrumento, incluindo reparos por deterioração ou infestação de cupins.",
  "areaServed": {
    "@type": "AdministrativeArea",
    "name": "São Paulo"
  },
  "url": "https://pianoswaldir.com.br/marcenaria"
};



  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  // Auto-rotatividade das imagens
  useEffect(() => {
    const interval = setInterval(() => {
      if (!isHovered) {
        setCurrentImageIndex((prevIndex) => 
          (prevIndex + 1) % galleryImages.length
        );
      }
    }, 5000); // Muda a cada 5 segundos
    
    return () => clearInterval(interval);
  }, [isHovered]);

  const currentImage = galleryImages[currentImageIndex];

  return (
     

    <div className="servico-marcenaria-container">
      
<SeoHead
  title="Serviço de Marcenaria para Pianos | Waldir Pianos"
  description="Recuperação profissional da madeira e estrutura do seu piano. Restauração especializada para devolver a beleza e funcionalidade do seu instrumento."
  keywords="marcenaria para piano, restauração de piano, recuperação madeira piano, Waldir Pianos, reparo cupim piano"
  image="/img/marcenaria/1.jpg"
  url="https://pianoswaldir.com.br/marcenaria"
  canonicalUrl="https://pianoswaldir.com.br/marcenaria"
  schemaMarkup={marcenariaSchema}
/>
      
      {/* Cabeçalho */}
      <motion.header
        className="servico-marcenaria-header"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="servico-marcenaria-header-content">
          <motion.h1
            className="servico-marcenaria-main-title"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            <GiWoodBeam className="servico-marcenaria-title-icon" />
            Serviço de Marcenaria
            <span className="servico-marcenaria-title-decoration"></span>
          </motion.h1>

          <motion.p
            className="servico-marcenaria-header-subtitle"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            A arte de restaurar a estrutura do seu piano
          </motion.p>
        </div>
      </motion.header>

      {/* Conteúdo Principal */}
      <div className="servico-marcenaria-main-content">
        {/* Seção de Texto */}
        <motion.section
          className="servico-marcenaria-text-section"
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.7 }}
        >
          <motion.div
            className="servico-marcenaria-text-content"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
          >
            <h2 className="servico-marcenaria-section-title">
              <GiWoodBeam className="servico-marcenaria-section-icon" />
              Recuperação da Madeira
            </h2>

            <p className="servico-marcenaria-classic-text">
              "Quando os danos atingem o interior da madeira, seja por deterioração ou por infestação de cupins, é necessário o serviço de marcenaria. Substituindo ou enxertando a madeira danificada e realizar a uniformização da cor inteira do piano para evitar diferenças que ocorrem por conta desta substituição do madeiramento original."
            </p>

            <div className="servico-marcenaria-modern-text">
              <p>Nossa equipe especializada em marcenaria de pianos cuida da integridade estrutural e estética do seu instrumento.</p>
              <p>Utilizamos técnicas avançadas de recuperação e seleção de madeiras compatíveis para garantir que a restauração seja duradoura e invisível, mantendo o valor e a beleza original do seu piano.</p>
            </div>

            <div className="servico-marcenaria-benefits-grid">
              <div className="servico-marcenaria-benefit-item">
                <GiWoodBeam className="servico-marcenaria-benefit-icon" />
                <span>Substituição ou enxerto de madeira danificada</span>
              </div>
              <div className="servico-marcenaria-benefit-item">
                <FaPaintRoller className="servico-marcenaria-benefit-icon" />
                <span>Uniformização da cor do piano</span>
              </div>
              <div className="servico-marcenaria-benefit-item">
                <FaCheckCircle className="servico-marcenaria-benefit-icon" />
                <span>Prevenção contra futuras deteriorações</span>
              </div>
            </div>
          </motion.div>
        </motion.section>

        <motion.section
        className="armazenagem-gallery-section"
        initial={{ opacity: 0, x: 30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, delay: 0.7 }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <h3 className="armazenagem-gallery-title">Nosso Espaço de Marcenaria</h3>
        
        <motion.div 
          className="armazenagem-gallery-container"
          key={currentImageIndex}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <div className="armazenagem-piano-image">
            <img 
              src={currentImage.src} 
              alt={currentImage.alt}
              className="armazenagem-gallery-image"
            />
            <div className="armazenagem-image-overlay">
              <span className="armazenagem-piano-description">
                {currentImage.alt}
              </span>
            </div>
          </div>
        </motion.div>
        
        {/* Pontos de navegação */}
        <div className="armazenagem-gallery-dots">
          {galleryImages.map((_, index) => (
            <button
              key={index}
              className={`armazenagem-dot ${index === currentImageIndex ? 'armazenagem-dot-active' : ''}`}
              onClick={() => setCurrentImageIndex(index)}
            />
          ))}
        </div>
      </motion.section>

      </div>

      {/* Rodapé */}
      <motion.footer
        className="servico-marcenaria-footer"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2 }}
      >
        <p className="servico-marcenaria-footer-text">Sua madeira precisa de restauração?</p>
        <motion.a
          href="tel:1122565987"
          className="servico-marcenaria-contact-button"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <FaPhone /> Fale Conosco
        </motion.a>
      </motion.footer>
    </div>
    
  );
};

export default ServicoMarcenaria;